import { render } from "./svgMenu.vue?vue&type=template&id=2e7cb506"
import script from "./svgMenu.vue?vue&type=script&lang=js"
export * from "./svgMenu.vue?vue&type=script&lang=js"

import exportComponent from "C:\\workspace\\repository\\sprfidspring\\src\\main\\vue-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__